import * as React from 'react';
import { Grid, Typography, withStyles, WithStyles } from 'material-ui';
const { SocialIcon } = require('react-social-icons');

import { AppBarPadding, invertedText } from '../utils/styles';

interface ContactPageProps extends WithStyles<keyof typeof styles> {}

const styles = {
  container: {
    ...AppBarPadding,
  },
  invertedText: {
    ...invertedText,
  },
};

export class ContactPage extends React.PureComponent<ContactPageProps> {
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Grid container justify="center" className={classes.container}>
          <Grid item xs={11} sm={10}>
            <Typography variant="display1" gutterBottom className={classes.invertedText}>
              Contact Info
            </Typography>
            <SocialIcon url="https://twitter.com/ApheleiaPress" />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ContactPage);



// WEBPACK FOOTER //
// ./src/pages/contact.tsx